import { api } from "./client";

export interface CheckCodeIn {
  code: string;
}

export interface CheckCodeOut {
  student_full_name: string;
  student_class: string | null;
  student_year: string;
}

export async function checkCode(payload: CheckCodeIn): Promise<CheckCodeOut> {
  const { data } = await api.post("/auth/check-code", payload);
  return data;
}

export interface RegisterIn {
  code: string;
  email: string;
  password: string;
  display_name: string;
  phone?: string;
  consent_pdn: boolean;
}

export interface AuthOut {
  token: string;
  parent_id: number;
  display_name: string;
}

export async function register(payload: RegisterIn): Promise<AuthOut> {
  const { data } = await api.post("/auth/register", payload);
  return data;
}

export async function login(email: string, password: string): Promise<AuthOut> {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function forgotPassword(email: string): Promise<void> {
  await api.post("/auth/forgot", { email });
}

export async function resetPassword(token: string, new_password: string): Promise<AuthOut> {
  const { data } = await api.post("/auth/reset", { token, new_password });
  return data;
}

export async function resetByCode(code: string, email: string, new_password: string): Promise<AuthOut> {
  const { data } = await api.post("/auth/reset-by-code", { code, email, new_password });
  return data;
}
